module.exports = __webpack_public_path__ + "static/media/GWE-PinwheelInstructions(ESP).1c1d2b35.pdf";